/* Program Name: LoadingModal.js
 **  Description: a pop up window with a spinner to indicate for users to wait
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/**React Hook import */
import React from 'react'

/**Material-UI imports */
import { CircularProgress } from '@mui/material'

/**LOADING MODAL***************************************************************/
/**this is a component that will display a spinner over a darken screen */
/**used for a waiting screen during async calls */

const LoadingModal = ({ message }) => {
  const styles = {
    /************************************************************************** */
    /**LOADING STYLES */

    //styles for the entire loading modal
    loadingModal: {
      height: '100vh',
      width: '100vw',
      backgroundColor: '#18191a',
      opacity: 0.3,
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 2000,
    },

    //styles for the icon inside the modal
    loadingModalIcon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      fontSize: 50,
      color: 'White',
    },
  }

  /******************************************************************************/
  /**Rendering */

  return (
    <div style={styles.loadingModal}>
      <div style={styles.loadingModalIcon}>
        {' '}
        {message ? message : '...Loading'} <CircularProgress color="inherit" />
      </div>
    </div>
  )
}

export default LoadingModal
